import { faPlus } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, Button, DashboardModule, Text,
} from '@domain-group/suit-theme'

import useAgencyPaymentMethod from '@hooks/useAgencyPaymentMethod'
import useAgencyPaymentMethods from '@hooks/useAgencyPaymentMethods'
import usePaymentMethods from '@hooks/usePaymentMethods'

import AgencyPaymentMethodListItem from './AgencyPaymentMethodListItem'

const AgencyPaymentMethods = (props: { agencyId: number }) => {
  const { agencyId } = props

  usePaymentMethods({ performHttpRequests: true })

  const agencyPaymentMethodPayload = useAgencyPaymentMethods({
    filters: { agency_id: agencyId },
    performHttpRequests: !!agencyId,
  })

  const {
    filteredAgencyPaymentMethods,
    hasAvailablePaymentMethods,
    hasFilteredAgencyPaymentMethods,
    loading,
  } = agencyPaymentMethodPayload

  const {
    callbacks: {
      createOrEditAgencyPaymentMethod,
    },
  } = useAgencyPaymentMethod({ agency_id: agencyId })

  return (
    <DashboardModule title="Payment Methods" loading={loading}>
      <Box flexDirection="column">
        <DashboardModule.ScrollableSection>
          {!loading && hasFilteredAgencyPaymentMethods && filteredAgencyPaymentMethods.map(AgencyPaymentMethod => (
            <AgencyPaymentMethodListItem
              AgencyPaymentMethod={AgencyPaymentMethod}
              key={AgencyPaymentMethod.id}
            />
          ))}
        </DashboardModule.ScrollableSection>

        {hasAvailablePaymentMethods && (
          <DashboardModule.Footer boxProps={{ borderTop: hasFilteredAgencyPaymentMethods ? '1px solid' : 'none' }}>
            {!loading && !hasFilteredAgencyPaymentMethods && (
            <Text
              color="bodyFontLightColor"
              display={['none', 'flex']}
              fontSize="small"
              variant="ellipsis"
              maxWidth="60%"
            >
              Payment Method Not Set
            </Text>
            )}

            <DashboardModule.FooterRight>
              <Button
                buttonStyle="secondaryEdit"
                icon={<FontAwesomeIcon icon={faPlus} />}
                onClick={() => createOrEditAgencyPaymentMethod()}
                // @ts-expect-error TS2322
                size={['medium', 'small']}
                width={['100%', 'fit-content']}
              >
                Add Payment Method
              </Button>
            </DashboardModule.FooterRight>
          </DashboardModule.Footer>
        )}
      </Box>
    </DashboardModule>
  )
}

export default AgencyPaymentMethods
